export const isTruthy = (value: unknown): boolean => Boolean(value);
export const isFalsy = (value: unknown): boolean => !Boolean(value);
export const isBooleanValue = (value: unknown): value is boolean =>
    typeof value === "boolean";